import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  AtsJob,
  BatchUpdateOrphanedAtsJobsRequest,
  HttpResponse,
} from "@/types";

export function useBatchUpdateOrphanedAtsJobs() {
  const mutation = useMutation({
    mutationFn: async ({
      batchUpdateOrphanedAtsJobsRequest,
    }: {
      batchUpdateOrphanedAtsJobsRequest: BatchUpdateOrphanedAtsJobsRequest;
    }) => {
      const path = `/ats-jobs/orphaned/batch`;
      const res = await guacHttpClient.patch<
        AtsJob[],
        HttpResponse<AtsJob[]>,
        BatchUpdateOrphanedAtsJobsRequest
      >(path, batchUpdateOrphanedAtsJobsRequest);

      return res.data;
    },
  });

  return mutation;
}
